import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { backend } = app;
const { urls } = backend;

export const RoleService = {
    /**
     * Get all roles
     * @param {Object} params
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    getAll: async ({
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RoleService.getAll';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            const dataObj = { conditionals: [], ordersBy: [], limit: 0 };
            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.roles}/`,
                data: dataObj,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Get role by ID
     * @param {Object} params
     * @param {string} params.id
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    getById: async ({
        id = '',
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RoleService.getById';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.get({
                url: `${urls?.url}${urls?.apiV1}${urls?.roles}/${id}`,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Save or Update a role
     * @param {Object} params
     * @param {Object} params.role
     * @param {string} params.token
     * @param {number} params.processType 0: Add, 1: Edit
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    save: async ({
        role = {},
        token = '',
        processType = 0,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RoleService.save';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            const url = `${urls?.url}${urls?.apiV1}${urls?.roles}/${processType === 0 ? '' : role?.id}`;

            response = await axiosV2?.post({
                url,
                data: role,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Delete a role
     * @param {Object} params
     * @param {string} params.id
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    delete: async ({
        id = '',
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RoleService.delete';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.delete({
                url: `${urls?.url}${urls?.apiV1}${urls?.roles}/${id}`,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }
};
